/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Project_Import_Media_Progress_In_ProgressInputs */

const en_team_project_import_media_progress_in_progress = /** @type {(inputs: Team_Project_Import_Media_Progress_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Progress...`)
};

const fr_team_project_import_media_progress_in_progress = /** @type {(inputs: Team_Project_Import_Media_Progress_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En cours...`)
};

const de_team_project_import_media_progress_in_progress = /** @type {(inputs: Team_Project_Import_Media_Progress_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Im Gange...`)
};

const it_team_project_import_media_progress_in_progress = /** @type {(inputs: Team_Project_Import_Media_Progress_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In corso...`)
};

const ru_team_project_import_media_progress_in_progress = /** @type {(inputs: Team_Project_Import_Media_Progress_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В ходе выполнения...`)
};

const es_team_project_import_media_progress_in_progress = /** @type {(inputs: Team_Project_Import_Media_Progress_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En curso...`)
};

const zh_cn2_team_project_import_media_progress_in_progress = /** @type {(inputs: Team_Project_Import_Media_Progress_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`进行中...`)
};

const ja_team_project_import_media_progress_in_progress = /** @type {(inputs: Team_Project_Import_Media_Progress_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`進行中...`)
};

const hi_team_project_import_media_progress_in_progress = /** @type {(inputs: Team_Project_Import_Media_Progress_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रगति पर है...`)
};

const pt_pt2_team_project_import_media_progress_in_progress = /** @type {(inputs: Team_Project_Import_Media_Progress_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em andamento...`)
};

/**
* | output |
* | --- |
* | "In Progress..." |
*
* @param {Team_Project_Import_Media_Progress_In_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_project_import_media_progress_in_progress = /** @type {((inputs?: Team_Project_Import_Media_Progress_In_ProgressInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Project_Import_Media_Progress_In_ProgressInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_project_import_media_progress_in_progress(inputs)
	if (locale === "de") return de_team_project_import_media_progress_in_progress(inputs)
	if (locale === "it") return it_team_project_import_media_progress_in_progress(inputs)
	if (locale === "ru") return ru_team_project_import_media_progress_in_progress(inputs)
	if (locale === "es") return es_team_project_import_media_progress_in_progress(inputs)
	if (locale === "zh-CN") return zh_cn2_team_project_import_media_progress_in_progress(inputs)
	if (locale === "ja") return ja_team_project_import_media_progress_in_progress(inputs)
	if (locale === "hi") return hi_team_project_import_media_progress_in_progress(inputs)
	if (locale === "pt-PT") return pt_pt2_team_project_import_media_progress_in_progress(inputs)
	return en_team_project_import_media_progress_in_progress(inputs)
});